import { render, staticRenderFns } from "./CustomerSwitch.vue?vue&type=template&id=13e25cec&"
import script from "./CustomerSwitch.vue?vue&type=script&lang=js&"
export * from "./CustomerSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../whitelabel/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports